import { createContext, useContext, useEffect, useState } from "react";

// Named Quote Workspace layouts a sales rep can switch between.
export const WORKSPACE_LAYOUTS = [
  {
    id: "classic",
    name: "Classic",
    tagline: "Dense KPI grid",
    description: "The original layout — full KPI strip on top, three-column workspace.",
  },
  {
    id: "command",
    name: "Command",
    tagline: "Control-room view",
    description: "Deal outcomes up top, sticky calculate, winner-highlighted carriers, chip accessorials.",
  },
  {
    id: "ltl",
    name: "LTL Quote",
    tagline: "Multi-item shipment",
    description: "Pickup/destination panels with multiple line items — catalog auto-stack or manual entry.",
  },
];

const KEY = "phs_workspace_layout";
const DEFAULT = "command";
const LayoutContext = createContext(null);

export function LayoutProvider({ children }) {
  const [layout, setLayoutState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem(KEY) : null;
    return WORKSPACE_LAYOUTS.some((l) => l.id === saved) ? saved : DEFAULT;
  });

  useEffect(() => {
    localStorage.setItem(KEY, layout);
  }, [layout]);

  const setLayout = (id) => {
    if (WORKSPACE_LAYOUTS.some((l) => l.id === id)) setLayoutState(id);
  };

  return (
    <LayoutContext.Provider value={{ layout, setLayout, layouts: WORKSPACE_LAYOUTS }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useWorkspaceLayout() {
  return useContext(LayoutContext) || { layout: DEFAULT, setLayout: () => {}, layouts: WORKSPACE_LAYOUTS };
}
